module.exports = __webpack_public_path__ + "static/img/2.6771263.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/2.png
// module id = ISJ8
// module chunks = 0